import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Package } from "@phosphor-icons/react";

export default function ReperePanel({ projectId }) {
  const [repere, setRepere] = useState([]);
  useEffect(() => {
    api.get(`/projects/${projectId}/repere`).then((r) => setRepere(r.data)).catch(() => {});
  }, [projectId]);

  return (
    <div className="rounded-xl border border-border bg-card p-6" data-testid="repere-panel">
      <h3 className="mb-4 flex items-center gap-2 font-head text-lg font-bold"><Package size={20} /> Repere primite (din avize)</h3>
      {repere.length === 0 ? (
        <p className="text-sm text-muted-foreground">Niciun reper alocat acestui proiect încă. Reperele apar automat după ce un aviz este scanat și liniile sunt atribuite acestui proiect.</p>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-border">
          <table className="w-full text-sm">
            <thead className="bg-white/5 text-xs uppercase text-muted-foreground">
              <tr>
                <th className="px-3 py-2 text-left">Denumire reper</th>
                <th className="px-3 py-2 text-left">UM</th>
                <th className="px-3 py-2 text-left">Cant.</th>
                <th className="px-3 py-2 text-left">Aviz</th>
                <th className="px-3 py-2 text-left">Dată</th>
              </tr>
            </thead>
            <tbody>
              {repere.map((r, i) => (
                <tr key={i} className="border-t border-border" data-testid={`reper-${i}`}>
                  <td className="px-3 py-2 font-medium">{r.product_name}</td>
                  <td className="px-3 py-2">{r.unit}</td>
                  <td className="px-3 py-2 tabular-nums">{r.quantity}</td>
                  <td className="px-3 py-2 text-muted-foreground">{r.aviz_number || "—"}</td>
                  <td className="px-3 py-2 text-muted-foreground">{r.aviz_date || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
